var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconFolderLockedSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconFolderLocked",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: _path || (_path = _jsx("path", {
        d: "m764.612 56 225.882 338.824H225.882v112.94H1920v504.057c0 23.83-30.833 30.72-42.353 9.939-58.052-104.245-169.299-175.172-296.47-175.172-186.353 0-338.824 152.47-338.824 338.824h-67.765c-24.96 0-45.176 20.216-45.176 45.176v463.06c0 19.2 2.259 38.4 5.647 56.47H169.412C75.896 1750.118 0 1674.334 0 1580.706V56h764.612Zm816.564 1016.47c62.231 0 112.942 50.711 112.942 112.942v112.94h-225.883v-112.94c0-62.23 50.71-112.941 112.941-112.941Zm225.883 112.942c0-124.574-101.195-225.883-225.883-225.883-124.687 0-225.882 101.309-225.882 225.883v112.94h-112.941v395.295c0 93.402 76.01 169.412 169.412 169.412h338.823c93.403 0 169.412-76.01 169.412-169.412v-395.294h-112.941v-112.941Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconFolderLockedSolid.glyphName = 'folder-locked';
IconFolderLockedSolid.variant = 'Solid';
IconFolderLockedSolid.displayName = 'IconFolderLockedSolid';
IconFolderLockedSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconFolderLockedSolid;
export { IconFolderLockedSolid };